(function() {
  'use strict';

  /* ======================================================
     Dimension Configurator INLINE — Décor Imprimé V39
     ------------------------------------------------------
     Cropper.js attached directly on top of the product image
     gallery (.primgSlider). When the customer enters Width
     and Height, the gallery jumps to the 3rd image (flat
     artwork) and a draggable crop frame appears on top.
     No modal. ATC capture happens transparently on submit.
     ====================================================== */

  var CLOUDINARY_CLOUD_NAME = 'djhyrckzq';
  var CLOUDINARY_UPLOAD_PRESET = 'decorimprime_crops';
  var FLAT_IMAGE_INDEX = 2; // 0-based, image 3

  var state = {
    width: 0,
    height: 0,
    unit: 'in',
    lang: 'fr',
    cropper: null,
    flatImageUrl: '',
    sliderEl: null,
    overlayEl: null,
    cropImgEl: null,
    pendingSubmit: false,
    submitting: false
  };

  var t = {
    fr: {
      bannerHint: 'Glissez pour ajuster votre cadrage.',
      legendPanels: 'Pointillés roses : joints des panneaux d’impression.',
      legendBleedIn: 'Bande rose : débord de 2 po (coupé à l’installation).',
      legendBleedCm: 'Bande rose : débord de 5 cm (coupé à l’installation).',
      preparingPreview: 'Préparation de l’aperçu…',
      cropAriaLabel: 'Aperçu du cadrage de votre murale, glissez pour ajuster'
    },
    en: {
      bannerHint: 'Drag to adjust your framing.',
      legendPanels: 'Pink dashed lines: print panel seams.',
      legendBleedIn: 'Pink strip: 2" bleed (trimmed at installation).',
      legendBleedCm: 'Pink strip: 5 cm bleed (trimmed at installation).',
      preparingPreview: 'Preparing preview…',
      cropAriaLabel: 'Mural framing preview, drag to adjust'
    }
  };

  function txt(key) { return (t[state.lang] || t.fr)[key] || key; }

  // ------ Init ------
  function init() {
    var productType = document.querySelector('[data-di-product-type]');
    if (!productType) return;

    var type = (productType.getAttribute('data-di-product-type') || '').toLowerCase();
    var allowed = ['murale', 'murales', 'papier peint', 'wallpaper', 'mural'];
    var ok = false;
    for (var i = 0; i < allowed.length; i++) { if (type.indexOf(allowed[i]) !== -1) { ok = true; break; } }
    if (!ok) return;

    var tags = (productType.getAttribute('data-di-product-tags') || '').toLowerCase();
    if (tags.indexOf('échantillon') !== -1 || tags.indexOf('sample') !== -1) return;
    if (tags.indexOf('no_repeat') === -1) return;

    state.lang = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0 ? 'en' : 'fr';

    detectFlatImage();
    if (!state.flatImageUrl) {
      pushEvent('di_cropper_load_failed', { reason: 'flat_image_missing' });
      return; // No 3rd image, silently skip
    }

    state.sliderEl = document.querySelector('.primgSlider');
    if (!state.sliderEl) {
      pushEvent('di_cropper_load_failed', { reason: 'slider_missing' });
      return;
    }

    createOverlay();
    attachCalcListeners();
    attachSliderListener();
    attachVariantListener();
    attachAtcInterceptor();
    updateAtcAriaLabel();
  }

  // Sticky ATC + ATC aria-label run on EVERY product page (autocollant, murale, etc.) — independent of cropper init.
  function initGlobalPdpEnhancements() {
    initStickyAtc();
    updateAtcAriaLabel();
    initCtaTracking();
  }

  // V40 — Track sample hero clicks + sticky ATC clicks for CRO measurement
  function initCtaTracking() {
    document.addEventListener('click', function(e) {
      var t = e.target.closest && e.target.closest('[data-di-track]');
      if (t) {
        var name = t.getAttribute('data-di-track');
        if (name) pushEvent('di_' + name, {});
      }
      // Sticky ATC click
      if (e.target.closest && e.target.closest('#diStickyAtcBtn')) {
        pushEvent('di_sticky_atc_click', {});
      }
    });
  }

  function detectFlatImage() {
    // Prefer non-cloned slick slides to avoid Slick duplicates
    var imgs = document.querySelectorAll('.primgSlider .product-single__photo:not(.slick-cloned) .product-featured-img');
    if (!imgs.length) imgs = document.querySelectorAll('.product-featured-img');
    if (imgs.length <= FLAT_IMAGE_INDEX) return;
    state.flatImageUrl = getImgUrl(imgs[FLAT_IMAGE_INDEX]);
  }

  function getImgUrl(el) {
    if (!el) return '';
    if (el.dataset && el.dataset.src) return el.dataset.src.replace('{width}', '1600');
    return el.currentSrc || el.src || '';
  }

  // ------ Overlay scaffold ------
  // V42 fix — size the overlay to match the FLAT IMAGE's rendered area, not the slider container.
  // On mobile, Slick adaptiveHeight letterboxes the image vertically (slider container taller
  // than the image's natural aspect). V41 used the slider's offsetHeight, which made Cropper
  // init in a too-tall container — the bleed strip ended up in the middle of the visible image.
  // V42 uses the flat image's natural ratio scaled to the slider width, so the overlay (and
  // the cropper canvas it contains) matches exactly the image's rendered bounds.
  function syncOverlaySize() {
    if (!state.overlayEl || !state.sliderEl) return;
    var w = state.sliderEl.offsetWidth;
    if (w <= 0) return;

    // Height MUST come from the flat image's true aspect ratio. Prefer Cropper's
    // own image data (authoritative once loaded), then the raw <img> natural size.
    // We deliberately do NOT fall back to state.sliderEl.offsetHeight: that is the
    // near-square height of whatever slide is currently showing (measured live at
    // 620px on a 620px-wide, 2:1 flat image = a 1:1 container). Because
    // `.cropper-container { height:100% !important }` force-couples Cropper's canvas
    // to this overlay, a wrong-aspect height stretches the near-square crop box into
    // a wide rectangle (the 98x96 "huge rectangle" bug). If the ratio isn't known
    // yet, leave the existing height untouched — Cropper init is gated on the image
    // load event, so a correct sync always lands before the user interacts.
    var natW = 0, natH = 0;
    if (state.cropper) {
      try {
        var idata = state.cropper.getImageData();
        if (idata && idata.naturalWidth > 0 && idata.naturalHeight > 0) {
          natW = idata.naturalWidth; natH = idata.naturalHeight;
        }
      } catch (e) { /* cropper not ready */ }
    }
    if (!natW && state.cropImgEl && state.cropImgEl.naturalWidth > 0 && state.cropImgEl.naturalHeight > 0) {
      natW = state.cropImgEl.naturalWidth; natH = state.cropImgEl.naturalHeight;
    }
    if (!natW || !natH) return; // ratio unknown → don't set a wrong-aspect height

    state.overlayEl.style.width = w + 'px';
    state.overlayEl.style.height = (w * (natH / natW)) + 'px';
  }

  function createOverlay() {
    var parent = state.sliderEl.parentNode;
    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    var overlay = document.createElement('div');
    overlay.className = 'di-inline-overlay';
    overlay.id = 'diInlineOverlay';
    overlay.setAttribute('role', 'region');
    overlay.setAttribute('aria-label', txt('cropAriaLabel'));
    overlay.style.display = 'none';
    // V42 — initial fallback sizing only. syncOverlaySize() recomputes once the
    // flat image is loaded (using its natural ratio), so mobile letterboxing
    // doesn't break the cropbox alignment.
    var initW = state.sliderEl.offsetWidth;
    var initH = state.sliderEl.offsetHeight;
    if (initW > 0) overlay.style.width = initW + 'px';
    if (initH > 0) overlay.style.height = initH + 'px';

    var imgWrapper = document.createElement('div');
    imgWrapper.className = 'di-inline-img-wrapper';

    var img = document.createElement('img');
    img.id = 'diInlineCropImg';
    img.crossOrigin = 'anonymous';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.style.display = 'block';
    img.style.maxWidth = '100%';
    imgWrapper.appendChild(img);

    overlay.appendChild(imgWrapper);
    parent.appendChild(overlay);

    // Banner is OUTSIDE the overlay (sibling), positioned UNDER the image area.
    // It only shows when cropper is active (toggled via .di-is-cropping body class CSS).
    var banner = document.createElement('div');
    banner.className = 'di-inline-banner di-inline-banner--below';
    banner.id = 'diInlineBanner';
    banner.textContent = txt('bannerHint');
    parent.appendChild(banner);

    state.overlayEl = overlay;
    state.cropImgEl = img;
  }

  // ------ Calculator listeners ------
  function attachCalcListeners() {
    var w = document.getElementById('width_edit');
    var h = document.getElementById('height_edit');
    var u = document.getElementById('unit');
    if (!w || !h) return;

    var debounced = debounce(onDimensionsChange, 250);
    w.addEventListener('input', debounced);
    h.addEventListener('input', debounced);
    if (u) u.addEventListener('change', debounced);

    // Bleed checkbox (#bleed = "Ne pas ajouter d'extra")
    var bleedCb = document.getElementById('bleed');
    if (bleedCb) bleedCb.addEventListener('change', function() {
      renderBleedOverlay();
      renderPanelLines();
      updateBannerText();
    });
  }

  function onDimensionsChange() {
    var wEl = document.getElementById('width_edit');
    var hEl = document.getElementById('height_edit');
    var uEl = document.getElementById('unit');
    var w = parseFloat(wEl && wEl.value) || 0;
    var h = parseFloat(hEl && hEl.value) || 0;
    var u = (uEl && uEl.value) || 'inches';
    state.unit = u === 'cm' ? 'cm' : 'in';

    // Min sanity: must be positive numbers
    if (w > 0 && h > 0 && w < 5000 && h < 5000) {
      state.width = w;
      state.height = h;
      activateCropper();
    } else {
      deactivateCropper();
    }
  }

  // ------ Slider control ------
  function forceSliderToFlat() {
    try {
      if (window.jQuery && window.jQuery(state.sliderEl).hasClass('slick-initialized')) {
        window.jQuery(state.sliderEl).slick('slickGoTo', FLAT_IMAGE_INDEX);
      }
    } catch (e) { /* no-op */ }
  }

  function attachSliderListener() {
    try {
      if (!window.jQuery) return;
      var $slider = window.jQuery(state.sliderEl);
      $slider.on('beforeChange', function(e, slick, current, next) {
        if (!state.cropper) return; // overlay not active
        if (next === FLAT_IMAGE_INDEX) {
          showOverlay();
        } else {
          hideOverlay();
        }
      });
      // After slick finishes its transition, resize Cropper so it picks up the
      // final container height (fixes broken first-render with adaptiveHeight).
      $slider.on('afterChange', function(e, slick, current) {
        if (!state.cropper) return;
        if (current === FLAT_IMAGE_INDEX) {
          // V41 fix — re-sync overlay size BEFORE resizing Cropper (adaptiveHeight
          // may have changed the slider height during the transition).
          syncOverlaySize();
          try { state.cropper.resize(); renderPanelLines(); renderBleedOverlay(); } catch (err) {}
        }
      });
    } catch (e) { /* no-op */ }
  }

  function attachVariantListener() {
    var form = document.querySelector('form[action*="/cart/add"]');

    // Catch radio-based variant selectors (.swatch input radios — DI uses these for matière)
    document.addEventListener('change', function(e) {
      if (!e.target) return;
      var t = e.target;
      var matches = (
        (t.matches && (t.matches('.swatch input') || t.matches('input[name^="option"]') || t.matches('input[name="id"]') || t.matches('select[name="id"]')))
        || (t.closest && t.closest('.swatch'))
      );
      if (matches) setTimeout(refreshFlatImage, 400);
    });

    // Catch label clicks on swatches (some themes only fire on labels)
    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('.swatch label, .swatchLbl, label.swatchLbl')) {
        setTimeout(refreshFlatImage, 500);
      }
    });

    // Theme-emitted variant change events (some themes use these)
    document.addEventListener('variant:change', function() { setTimeout(refreshFlatImage, 200); });
    document.addEventListener('product:variantchange', function() { setTimeout(refreshFlatImage, 200); });
  }

  // V40 fix — sledgehammer approach: always recreate cropper after variant change.
  // Shopify variant changes can swap product-featured-img elements, re-init slick,
  // or break Cropper.js internals. Safer to fully recreate from current dims than
  // try to surgically update.
  function refreshFlatImage() {
    var wEl = document.getElementById('width_edit');
    var hEl = document.getElementById('height_edit');
    var w = parseFloat(wEl && wEl.value) || 0;
    var h = parseFloat(hEl && hEl.value) || 0;
    if (w <= 0 || h <= 0 || w >= 5000 || h >= 5000) return; // no valid dims, nothing to do

    // Re-detect flat image (DOM may have new img elements after variant swap)
    detectFlatImage();
    if (!state.flatImageUrl) return;

    // Persist dims
    state.width = w;
    state.height = h;
    var uEl = document.getElementById('unit');
    state.unit = (uEl && uEl.value === 'cm') ? 'cm' : 'in';

    // Update overlay image src to current variant's flat image
    if (state.cropImgEl) state.cropImgEl.src = state.flatImageUrl;

    // Destroy any existing cropper, then recreate cleanly
    if (state.cropper) {
      try { state.cropper.destroy(); } catch (e) {}
      state.cropper = null;
    }
    setTimeout(function() {
      activateCropper();
    }, 120);
  }

  // ------ Cropper lifecycle ------
  function activateCropper() {
    if (!state.cropImgEl) return;
    if (typeof Cropper === 'undefined') {
      pushEvent('di_cropper_load_failed', { reason: 'cropper_lib_undefined' });
      return;
    }

    var wasActive = !!state.cropper;
    state.overlayEl.style.display = 'block';
    document.body.classList.add('di-is-cropping');
    forceSliderToFlat();

    var ratio = state.width / state.height;

    if (state.cropper) {
      state.cropper.setAspectRatio(ratio);
      renderPanelLines();
      updateAtcAriaLabel();
      return;
    }

    if (!wasActive) {
      pushEvent('di_cropper_activated', { unit: state.unit, w: state.width, h: state.height });
    }
    updateAtcAriaLabel();
    updateBannerText();

    // First load: set src then init
    if (!state.cropImgEl.src || state.cropImgEl.src !== state.flatImageUrl) {
      state.cropImgEl.src = state.flatImageUrl;
    }

    var opts = {
      aspectRatio: ratio,
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 1,
      responsive: true,
      restore: false,
      guides: false,
      center: false,
      highlight: false,
      background: false,
      cropBoxMovable: true,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      zoomable: false,
      zoomOnTouch: false,
      zoomOnWheel: false,
      crop: function() { renderPanelLines(); renderBleedOverlay(); trackRepositioned(); },
      ready: function() { renderPanelLines(); renderBleedOverlay(); }
    };

    // Wait for both image load AND slick afterChange to settle, otherwise
    // Cropper inits with a transitioning container size and renders broken.
    var initCropperNow = function() {
      if (state.cropper) return;
      try {
        state.cropper = new Cropper(state.cropImgEl, opts);
      } catch (e) {
        pushEvent('di_cropper_load_failed', { reason: 'cropper_init_exception' });
      }
    };

    var afterImgLoaded = function() {
      // V41 fix — wait 350ms (was 80ms) so Slick adaptiveHeight finishes its CSS
      // transition (~300ms default) before Cropper.js measures the container.
      // Then do a second resize pass at 750ms for edge cases (slow devices / large images).
      setTimeout(function() {
        syncOverlaySize(); // ensure overlay matches slider's settled height
        initCropperNow();
        setTimeout(function() {
          if (state.cropper && typeof state.cropper.resize === 'function') {
            syncOverlaySize();
            try { state.cropper.resize(); renderPanelLines(); renderBleedOverlay(); } catch (e) {}
          }
        }, 750); // was 450ms
      }, 350); // was 80ms
    };

    if (state.cropImgEl.complete && state.cropImgEl.naturalWidth > 0) {
      afterImgLoaded();
    } else {
      state.cropImgEl.addEventListener('load', function once() {
        state.cropImgEl.removeEventListener('load', once);
        afterImgLoaded();
      });
    }
  }

  function deactivateCropper() {
    if (state.cropper) {
      try { state.cropper.destroy(); } catch (e) {}
      state.cropper = null;
    }
    state.width = 0;
    state.height = 0;
    if (state.overlayEl) state.overlayEl.style.display = 'none';
    document.body.classList.remove('di-is-cropping');
  }

  function showOverlay() { if (state.overlayEl) state.overlayEl.style.display = 'block'; }
  function hideOverlay() { if (state.overlayEl) state.overlayEl.style.display = 'none'; }

  // ------ Bleed overlay (V40 fix #2) — strips appended to overlayEl parent ------
  // DI bleed = 2"(or 5 cm) added to width (RIGHT side) + 2"(or 5 cm) added to height (BOTTOM).
  // Customer enters 120×48 → printed 122×50. Strips render OUTSIDE the crop, on the right
  // and bottom edges. Appended to state.overlayEl (no overflow:hidden) instead of cropper-container.
  function renderBleedOverlay() {
    // Always remove previous strips/labels first (toggle support)
    if (state.overlayEl) {
      var olds = state.overlayEl.querySelectorAll('.di-bleed-strip, .di-bleed-strip__label, .di-bleed-overlay');
      olds.forEach(function(el) { el.parentNode.removeChild(el); });
    }

    if (!state.cropper || !state.width) return;

    var bleedCb = document.getElementById('bleed');
    if (bleedCb && bleedCb.checked) return;

    var cropBox = state.cropper.getCropBoxData();
    if (!cropBox || !cropBox.width || !cropBox.height) return;

    var container = state.overlayEl.querySelector('.cropper-container');
    if (!container) return;

    var bleedTotal = state.unit === 'cm' ? 5 : 2;
    var pxPerUnit = cropBox.width / state.width;
    var bleedPx = bleedTotal * pxPerUnit;
    if (bleedPx <= 0 || !isFinite(bleedPx)) return;
    // Sanity: don't render if bleed would consume the entire crop
    if (bleedPx >= cropBox.width || bleedPx >= cropBox.height) return;
    // Visibility floor: ensure strip is at least 12px so it's clearly noticeable
    // even on portrait/wide aspect crops where physical bleed is small relative to crop
    var visualBleedPx = Math.max(bleedPx, 12);

    var bleedColor = 'rgba(255, 77, 158, 0.62)';
    var bleedBorder = '2px dashed #ff4d9e';
    var Z = 9999;

    // V40 fix #5 — bleed strips INSIDE the crop frame, at right + bottom edges.
    // High z-index (9999) to override any Cropper.js internal layer.
    // Visual minimum 6px so strips are always noticeable even on small physical bleed values.

    // Bottom strip FIRST (so it draws under the right strip's corner — corner belongs to right)
    var bottomStrip = document.createElement('div');
    bottomStrip.className = 'di-bleed-strip di-bleed-strip--bottom';
    bottomStrip.style.cssText = 'position:absolute;pointer-events:none;box-sizing:border-box;background:' + bleedColor + ';border-top:' + bleedBorder + ';z-index:' + Z + ';';
    bottomStrip.style.left = cropBox.left + 'px';
    bottomStrip.style.top = (cropBox.top + cropBox.height - visualBleedPx) + 'px';
    bottomStrip.style.width = cropBox.width + 'px';
    bottomStrip.style.height = visualBleedPx + 'px';
    container.appendChild(bottomStrip);

    // Right strip (drawn after bottom so it's on top in the corner)
    var rightStrip = document.createElement('div');
    rightStrip.className = 'di-bleed-strip di-bleed-strip--right';
    rightStrip.style.cssText = 'position:absolute;pointer-events:none;box-sizing:border-box;background:' + bleedColor + ';border-left:' + bleedBorder + ';z-index:' + (Z + 1) + ';';
    rightStrip.style.left = (cropBox.left + cropBox.width - visualBleedPx) + 'px';
    rightStrip.style.top = cropBox.top + 'px';
    rightStrip.style.width = visualBleedPx + 'px';
    rightStrip.style.height = cropBox.height + 'px';
    container.appendChild(rightStrip);
  }

  // V40 fix #3 — dynamic banner text under image (replaces floating corner label).
  // Combines: drag instruction + panels legend + bleed legend (if active).
  function updateBannerText() {
    var banner = document.getElementById('diInlineBanner');
    if (!banner) return;
    var bleedCb = document.getElementById('bleed');
    var bleedHidden = bleedCb && bleedCb.checked;
    var lines = [txt('bannerHint'), txt('legendPanels')];
    if (!bleedHidden) {
      lines.push(state.unit === 'cm' ? txt('legendBleedCm') : txt('legendBleedIn'));
    }
    banner.innerHTML = lines.join('<br>');
  }

  // ------ Panel lines ------
  function renderPanelLines() {
    if (!state.cropper || !state.width) return;
    var cropBox = state.cropper.getCropBoxData();
    if (!cropBox || !cropBox.width) return;

    // Remove previous overlay
    var old = state.overlayEl.querySelector('.di-panel-overlay');
    if (old) old.parentNode.removeChild(old);

    var container = state.overlayEl.querySelector('.cropper-container');
    if (!container) return;

    var overlay = document.createElement('div');
    overlay.className = 'di-panel-overlay';
    overlay.style.position = 'absolute';
    overlay.style.left = cropBox.left + 'px';
    overlay.style.top = cropBox.top + 'px';
    overlay.style.width = cropBox.width + 'px';
    overlay.style.height = cropBox.height + 'px';
    overlay.style.pointerEvents = 'none';
    overlay.style.zIndex = '5';

    var panelSize = state.unit === 'cm' ? 66 : 26;
    if (state.width > panelSize) {
      var nbPanels = Math.floor(state.width / panelSize);
      var pxPerUnit = cropBox.width / state.width;
      for (var i = 1; i <= nbPanels; i++) {
        var offset = i * panelSize * pxPerUnit;
        if (offset >= cropBox.width - 1) break;
        var line = document.createElement('div');
        line.className = 'di-panel-line';
        line.style.position = 'absolute';
        line.style.top = '0';
        line.style.bottom = '0';
        line.style.left = offset + 'px';
        line.style.borderLeft = '2px dashed #ff4d9e';
        overlay.appendChild(line);
      }
    }
    container.appendChild(overlay);
  }

  // ------ ATC interception ------
  function attachAtcInterceptor() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      if (state.submitting) return;        // Already in our resubmit path
      if (!state.cropper) return;          // No cropper active, normal flow
      var existing = form.querySelector('input[name="properties[_Aperçu du cadrage]"]');
      if (existing && existing.value && existing.value.indexOf('http') === 0) return; // Already uploaded

      e.preventDefault();
      e.stopPropagation();
      state.pendingSubmit = true;
      processCropToCart(form);
    }, true); // capture
  }

  function processCropToCart(form) {
    if (!state.cropper) {
      pushEvent('di_cropper_atc_no_url', { reason: 'no_cropper_at_atc' });
      finalizeSubmit(form);
      return;
    }
    saveCropDataToForm(form);

    var canvas = generateCanvasWithLines();
    if (!canvas) {
      pushEvent('di_cropper_atc_no_url', { reason: 'canvas_generation_failed' });
      finalizeSubmit(form);
      return;
    }
    var dataUrl = canvas.toDataURL('image/jpeg', 0.85);
    setHiddenInput(form, '_crop_preview', dataUrl); // fallback if Cloudinary fails

    uploadToCloudinary(dataUrl, form, function() {
      if (state.pendingSubmit) {
        var preview = form.querySelector('input[name="properties[_Aperçu du cadrage]"]');
        if (preview && preview.value && preview.value.indexOf('http') === 0) {
          pushEvent('di_cropper_atc', { unit: state.unit, w: state.width, h: state.height });
        } else {
          pushEvent('di_cropper_atc_no_url', { reason: 'cloudinary_no_url' });
        }
        finalizeSubmit(form);
      }
    });
  }

  function finalizeSubmit(form) {
    state.pendingSubmit = false;
    state.submitting = true;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
    setTimeout(function() { state.submitting = false; }, 1500);
  }

  // Bug fix (3 août 2026) — le listener input est débouncé (250ms) avant d'appeler
  // setAspectRatio(). Si le client clique "Ajouter au panier" dans cette fenêtre
  // (juste après avoir fini de taper ses dimensions), le crop capturé reflète encore
  // un ratio intermédiaire de la frappe précédente (ex. hauteur="9" avant "97"),
  // produisant un _crop_rect complètement disproportionné par rapport aux vraies
  // dimensions commandées. On force ici une synchro immédiate (non débouncée) juste
  // avant de lire la géométrie du crop, pour garantir qu'elle correspond aux valeurs
  // actuelles des champs, peu importe l'état du timer de debounce.
  function flushPendingDimensions() {
    var wEl = document.getElementById('width_edit');
    var hEl = document.getElementById('height_edit');
    var w = parseFloat(wEl && wEl.value) || 0;
    var h = parseFloat(hEl && hEl.value) || 0;
    if (w <= 0 || h <= 0 || w >= 5000 || h >= 5000) return;
    if (w === state.width && h === state.height) return; // already in sync
    state.width = w;
    state.height = h;
    if (state.cropper) {
      state.cropper.setAspectRatio(state.width / state.height);
    }
  }

  function saveCropDataToForm(form) {
    flushPendingDimensions();
    if (!state.cropper) return;
    var data = state.cropper.getData(true);
    var imgData = state.cropper.getImageData();
    if (!imgData.naturalWidth || !imgData.naturalHeight) return;
    var x = Math.round((data.x / imgData.naturalWidth) * 100);
    var y = Math.round((data.y / imgData.naturalHeight) * 100);
    var w = Math.round((data.width / imgData.naturalWidth) * 100);
    var h = Math.round((data.height / imgData.naturalHeight) * 100);
    setHiddenInput(form, '_crop_rect', 'x=' + x + '% y=' + y + '% w=' + w + '% h=' + h + '%');
    setHiddenInput(form, '_crop_frame', state.width + 'x' + state.height + ' ' + state.unit);
    removeHiddenInput(form, '_crop_x_percent');
    removeHiddenInput(form, '_crop_y_percent');
    removeHiddenInput(form, '_crop_w_percent');
    removeHiddenInput(form, '_crop_h_percent');
    removeHiddenInput(form, '_crop_preview_url');
    removeHiddenInput(form, '_crop_image_url');
  }

  function generateCanvasWithLines() {
    if (!state.cropper) return null;
    var canvas;
    try {
      canvas = state.cropper.getCroppedCanvas({ maxWidth: 800, maxHeight: 800, fillColor: '#fff' });
    } catch (e) { return null; }
    if (!canvas) return null;
    var ctx = canvas.getContext('2d');
    if (!ctx || !state.width) return canvas;

    var panelSize = state.unit === 'cm' ? 66 : 26;
    if (state.width > panelSize) {
      var nbPanels = Math.floor(state.width / panelSize);
      var pxPerUnit = canvas.width / state.width;
      ctx.strokeStyle = '#ff4d9e';
      ctx.lineWidth = 2;
      if (ctx.setLineDash) ctx.setLineDash([6, 4]);
      for (var p = 1; p <= nbPanels; p++) {
        var xLine = p * panelSize * pxPerUnit;
        if (xLine >= canvas.width - 1) break;
        ctx.beginPath();
        ctx.moveTo(xLine, 0);
        ctx.lineTo(xLine, canvas.height);
        ctx.stroke();
      }
    }
    return canvas;
  }

  // ------ Cloudinary upload ------
  function uploadToCloudinary(dataUrl, form, callback) {
    if (!dataUrl || typeof fetch === 'undefined') { if (callback) callback(); return; }
    setSubmitButtonState(form, true, txt('preparingPreview'));
    var safetyTimer = setTimeout(function() {
      setSubmitButtonState(form, false);
      if (callback) callback();
    }, 15000);

    try {
      var fd = new FormData();
      fd.append('file', dataUrlToBlob(dataUrl));
      fd.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
      fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD_NAME + '/image/upload', {
        method: 'POST', body: fd
      })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (data && data.secure_url) {
          setHiddenInput(form, '_Aperçu du cadrage', data.secure_url);
          removeHiddenInput(form, 'Aperçu du cadrage');
          removeHiddenInput(form, '_crop_preview');
        }
      })
      .catch(function() { /* fallback in _crop_preview still works */ })
      .then(function() {
        clearTimeout(safetyTimer);
        setSubmitButtonState(form, false);
        if (callback) callback();
      });
    } catch (e) {
      clearTimeout(safetyTimer);
      setSubmitButtonState(form, false);
      if (callback) callback();
    }
  }

  function dataUrlToBlob(dataUrl) {
    var parts = dataUrl.split(',');
    var byteString = atob(parts[1]);
    var mimeString = parts[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    return new Blob([ab], { type: mimeString });
  }

  // ------ Form helpers ------
  function setHiddenInput(form, name, value) {
    var fullName = 'properties[' + name + ']';
    var existing = form.querySelector('input[name="' + fullName + '"]');
    if (existing) {
      existing.value = value;
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = fullName;
      input.value = value;
      form.appendChild(input);
    }
  }

  function removeHiddenInput(form, name) {
    var fullName = 'properties[' + name + ']';
    var existing = form.querySelector('input[name="' + fullName + '"]');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
  }

  function setSubmitButtonState(form, disabled, label) {
    if (!form) return;
    var buttons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    buttons.forEach(function(btn) {
      btn.disabled = disabled;
      if (label) {
        if (!btn.dataset.diOriginalLabel) btn.dataset.diOriginalLabel = btn.innerHTML || btn.value;
        if (btn.tagName === 'BUTTON') btn.innerHTML = label;
        else btn.value = label;
      } else if (btn.dataset.diOriginalLabel) {
        if (btn.tagName === 'BUTTON') btn.innerHTML = btn.dataset.diOriginalLabel;
        else btn.value = btn.dataset.diOriginalLabel;
        delete btn.dataset.diOriginalLabel;
      }
    });
  }

  function debounce(fn, ms) {
    var timer;
    return function() {
      var args = arguments, ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(ctx, args); }, ms);
    };
  }

  // ------ V40 Tracking (GA4 + dataLayer) ------
  function pushEvent(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var ev = { event: name };
        if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) ev[k] = params[k];
        window.dataLayer.push(ev);
      }
    } catch (e) { /* tracking must never break UX */ }
  }

  var trackRepositioned = debounce(function() {
    if (!state.cropper) return;
    pushEvent('di_cropper_repositioned', { unit: state.unit, w: state.width, h: state.height });
  }, 1500);

  // ------ V40 Agentic — ATC aria-label enrichment ------
  function updateAtcAriaLabel() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var btns = form.querySelectorAll('button[type="submit"][name="add"], button#AddToCart-' + (form.dataset.sectionId || ''));
    if (!btns.length) btns = form.querySelectorAll('button[type="submit"]');

    var titleEl = document.querySelector('.product-single__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var dim = state.width && state.height ? state.width + '×' + state.height + ' ' + (state.unit === 'cm' ? 'cm' : 'po') : '';
    var variantSel = form.querySelector('select[name="id"]');
    var variantText = '';
    if (variantSel && variantSel.options[variantSel.selectedIndex]) {
      variantText = (variantSel.options[variantSel.selectedIndex].text || '').replace(/\s*-\s*[\d.,$]+.*$/, '').trim();
    }
    var priceEl = document.querySelector('[id^="ProductPrice-"]');
    var price = priceEl ? priceEl.textContent.trim() : '';

    var label;
    if (state.lang === 'en') {
      label = 'Add to cart — ' + title;
      if (dim) label += ', ' + dim;
      if (variantText) label += ', ' + variantText;
      if (price) label += ', ' + price;
    } else {
      label = 'Ajouter au panier — ' + title;
      if (dim) label += ', ' + dim;
      if (variantText) label += ', ' + variantText;
      if (price) label += ', ' + price;
    }

    btns.forEach(function(btn) { btn.setAttribute('aria-label', label); });
  }

  // Re-update on dimension change
  var debouncedAriaUpdate = debounce(updateAtcAriaLabel, 300);
  document.addEventListener('input', function(e) {
    if (e.target && (e.target.id === 'width_edit' || e.target.id === 'height_edit')) debouncedAriaUpdate();
  });
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.id === 'unit' || e.target.name === 'id')) debouncedAriaUpdate();
  });

  // ------ V40 Sticky ATC mobile ------
  function initStickyAtc() {
    var bar = document.getElementById('diStickyAtc');
    var btn = document.getElementById('diStickyAtcBtn');
    if (!bar || !btn) return;

    // Find the real ATC button to observe
    var realBtn = document.getElementById('AddToCart-' + (document.querySelector('[id^="AddToCart-"]') ? document.querySelector('[id^="AddToCart-"]').id.replace('AddToCart-', '') : ''));
    if (!realBtn) realBtn = document.querySelector('button.product-form__cart-submit-custom');
    if (!realBtn) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });
      observer.observe(realBtn);
    } else {
      // Fallback: always visible
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }

    btn.addEventListener('click', function() {
      realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Brief highlight
      realBtn.classList.add('di-atc-flash');
      setTimeout(function() { realBtn.classList.remove('di-atc-flash'); }, 1200);
    });

    // Update sticky price on variant change
    document.addEventListener('variant:change', updateStickyPrice);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', function(e) {
      if (e.target && e.target.name === 'id') setTimeout(updateStickyPrice, 200);
    });
  }

  function updateStickyPrice() {
    var stickyPrice = document.getElementById('diStickyPriceVal');
    var realPrice = document.querySelector('[id^="ProductPrice-"]');
    if (stickyPrice && realPrice) stickyPrice.textContent = realPrice.textContent.trim();
  }

  // ------ Init ------
  function bootstrap() {
    init();                       // cropper init (gated to murale + no_repeat)
    initGlobalPdpEnhancements();  // sticky ATC + aria-label, all products
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
